<template>
  <div>
    <page-header title="Dodaj kursanta" />
    <form-wrapper
      ref="form"
      :service="Student"
      :formComponent="InnerForm"
      :form.sync="form"
      :errors.sync="errors"
      :objParams="$route.params.studentId"
      :getSuccessRoute="getSuccessRoute"
      class="c-box"
      success-message="Kursant dodany"
    />
  </div>
</template>
<script>
import { Student } from '@/api'
import InnerForm from '@/components/forms/StudentForm'

export default {
  data() {
    return {
      InnerForm,
      Student,
      form: {
        receive_email_notifications: true
      },
      errors: {}
    }
  },
  methods: {
    getSuccessRoute: res => ({
      path: `/admin/kursanci/szczegoly/${res.data.id}/edytuj/`
    })
  }
}
</script>
